import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/book',
            name: 'master',
            component(resolve) {
                require.ensure(['../views/master.vue'], () => {
                    resolve(require('../views/master.vue'));
                });
            },
            children: [
                {
                    path: '/register',
                    name: 'register',
                    component(resolve) {
                        require.ensure(['../views/register.vue'], () => {
                            resolve(require('../views/register.vue'));
                        });
                    },
                },
            ]
        },
        {
            path: '/',
            name: 'home',
            component(resolve) {
                require.ensure(['../views/home.vue'], () => {
                    resolve(require('../views/home.vue'));
                });
            },
        },
        {
            path: '/home',
            name: 'home',
            component(resolve) {
                require.ensure(['../views/home.vue'], () => {
                    resolve(require('../views/home.vue'));
                });
            },
        },
        {
            path: '/news',
            name: 'news',
            component(resolve) {
                require.ensure(['../views/news.vue'], () => {
                    resolve(require('../views/news.vue'));
                });
            },
        },
        {
            path: '/monster_view',
            name: 'monster_view',
            component(resolve) {
                require.ensure(['../views/monster_view.vue'], () => {
                    resolve(require('../views/monster_view.vue'));
                });
            },
        },
        {
            path: '/prop_view',
            name: 'prop_view',
            component(resolve) {
                require.ensure(['../views/prop_view.vue'], () => {
                    resolve(require('../views/prop_view.vue'));
                });
            },
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js